import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { CountrySelectorSimple } from '@cotyorg/ccx-organism-country-selector';
import { SocialNewsletterSimple } from '@cotyorg/ccx-organism-social-newsletter';
import FooterList from '../FooterList/FooterList';
import FooterAccordion from '../FooterAccordion/FooterAccordion';
import Copyright from '../Copyright/Copyright';

const FooterCombined = ({
  footer,
  currentBreakpoint,
  showCountrySelector = false,
  showSocialNewsletter = false,
  chevronIconSrc,
  socialIconSrc,
  buttonIconSrc,
  minusIconSrc,
  plusIconSrc,
  headingLevel = 5,
}) => {
  const { copyright, country } = footer;

  const { text } = copyright;
  const sectionHeader = country ? country.sectionHeader : null;

  const isLargeBreakpoint = currentBreakpoint && currentBreakpoint.includes('large');

  return (
    <footer className="footer" >
      { isLargeBreakpoint && (
        <FooterList
          footer={footer}
          extraClass="footer-list--combined"
          headingLevel={headingLevel}
          forceSectionTitles
        >
          <Fragment>
            {
              showCountrySelector && (
                <Fragment>
                  <span className="navigation__section-title">{sectionHeader}</span>
                  <CountrySelectorSimple
                    extraClass="footer-combined__country-selector--list"
                    extraSelectClass="footer-combined__select--list"
                    chevronIconSrc={chevronIconSrc}
                  />
                </Fragment>
              )
            }
            {
              showSocialNewsletter && (
                <SocialNewsletterSimple
                  headingLevel={6}
                  headingUnderlined={false}
                  buttonType="icon"
                  socialNewsletterStoreDataKey="SocialNewsletterSimple"
                  socialIconSrc={socialIconSrc}
                  buttonIconSrc={buttonIconSrc}
                  extraClass="footer-combined__newsletter--list"
                />
              )
            }
          </Fragment>
        </FooterList>
      )}
      { !isLargeBreakpoint && (
        <FooterAccordion
          footer={footer}
          extraClass="footer-accordion--combined"
          openAccordionButtonExtraClass="footer-accordion__accordion-button"
          accordionBodyExtraClass="footer-accordion__accordion-body"
          minusIconSrc={minusIconSrc}
          plusIconSrc={plusIconSrc}
        >
          <Fragment>
            {
              showCountrySelector && (
                <CountrySelectorSimple
                  extraClass="footer-combined__country-selector"
                  extraSelectClass="footer-combined__select--accordion"
                  chevronIconSrc={chevronIconSrc}
                />
              )
            }
            {
              showSocialNewsletter && (
                <SocialNewsletterSimple
                  headingLevel={3}
                  headingUnderlined={false}
                  buttonType="icon"
                  socialNewsletterStoreDataKey="SocialNewsletterSimple"
                  socialIconSrc={socialIconSrc}
                  buttonIconSrc={buttonIconSrc}
                  extraClass="footer-combined__newsletter--accordion"
                />
              )
            }
          </Fragment>
        </FooterAccordion>
      )}
      <Copyright text={text} extraClass="copyright__message--combined" />
    </footer>
  );
};

FooterCombined.propTypes = {
  footer: PropTypes.shape({
    pages: PropTypes.array.isRequired,
    card: PropTypes.object,
    copyright: PropTypes.shape({
      text: PropTypes.string.isRequired,
    }).isRequired,
    country: PropTypes.shape({
      sectionHeader: PropTypes.string,
    }),
  }).isRequired,
  showCountrySelector: PropTypes.bool,
  currentBreakpoint: PropTypes.string.isRequired,
  showSocialNewsletter: PropTypes.bool,
  chevronIconSrc: PropTypes.string,
  buttonIconSrc: PropTypes.string,
  socialIconSrc: PropTypes.objectOf(PropTypes.string),
  plusIconSrc: PropTypes.string,
  minusIconSrc: PropTypes.string,
  headingLevel: PropTypes.number,
};

export default FooterCombined;
